import { useMemo } from "react";
import { useProducts } from "../../admin/products/useProducts";
import { useProviders } from "../../admin/providers/useProviders";
import type { OrderProduct, SavedOrderProduct } from "../orderTypes";
import { calculateDefaultCancellationDate } from "./calculateDefaultCancellationDate";

interface OrderInput {
  readonly products: (OrderProduct | SavedOrderProduct)[];
  readonly cancellationDate?: string | null;
  readonly freeCancellationDate?: string;
}

export function useOrderDefaultCancellationDate(order: OrderInput): string | null | undefined {
  const { providers } = useProviders();
  const { products: catalog } = useProducts();

  const productsKey = order.products.map((p) => `${p.id}|${p.date}|${"providerId" in p ? p.providerId : ""}`).join(",");
  const defaultCancellationDate = useMemo(
    () => calculateDefaultCancellationDate(order.products, providers, catalog),
    [productsKey, providers, catalog],
  );

  return order.cancellationDate ?? defaultCancellationDate ?? order.freeCancellationDate;
}
